import { sendGoogleEvent, sendRequest } from '@html/_common/utils';

import copyTextToClipboard from '@html/_utils/copy-text-to-clipboard';

export default class AOTourTravelAgentLoginPrompt {
  constructor(tourId) {
    this.eventCategory = 'TDP log-in pop-up';
    this.eventLabel = 'Travel Agent/ Client';
    this.TEMPLATE_ENDPOINT = '/api/popup/travel-agent';

    this.selectors = {
      overlay: '.js-ao-common-travel-agent-login-prompt__overlay',
      close: '.js-ao-common-travel-agent-login-prompt__close, .js-ao-common-travel-agent-login-prompt__cancel',
      loginBtn: '.js-ao-common-travel-agent-login-prompt__cta',
      copyTrigger: '.js-ao-common-travel-agent-login-prompt__copy-trigger',
      contentToCopy: '.js-ao-common-travel-agent-login-prompt__copy-content',
    };
    this.loadingCtaClass = 'ao-common-travel-agent--loading';

    this.tourId = tourId;
    this.popupLoading = false;
    this.currentQueryData = '';
  }

  static getTriggerSelector() {
    return '.js-ao-common-travel-agent-login-prompt__trigger';
  }

  init() {
    $(document).on(
      'click',
      AOTourTravelAgentLoginPrompt.getTriggerSelector(),
      (event) => {
        event.preventDefault();
        if (this.popupLoading) {
          return;
        }
        const $target = $(event.target);
        const queryData = $target.data('query');

        if (queryData === this.currentQueryData) {
          this.open();
          return;
        }

        this.currentQueryData = queryData;
        $target.addClass(this.loadingCtaClass);

        this.loadPopup({
          queryParams: this.currentQueryData,
          successCallback: () => {
            this.open();
          },
          finalCallback: () => {
            $target.removeClass(this.loadingCtaClass);
          },
        });
      },
    );

    $(document).on('click', this.selectors.close, () => {
      this.close();
    });

    $(document).on('click', this.selectors.loginBtn, () => {
      sendGoogleEvent(
        this.eventCategory,
        'Click the “Login” button',
        this.eventLabel,
      );
    });
  }

  open() {
    $(this.selectors.overlay).removeClass('hid');

    $(this.selectors.copyTrigger).on('click', () => {
      copyTextToClipboard(
        $(this.selectors.contentToCopy).text(),
        () => {
          this.showSuccessToast($(this.selectors.copyTrigger).data('success'));
        },
      );
    });
    sendGoogleEvent(
      this.eventCategory,
      'BNP Login Prompt',
      this.eventLabel,
    );
  }

  close() {
    $(this.selectors.overlay).addClass('hid');
    sendGoogleEvent(
      this.eventCategory,
      'Click the Cancel button',
      this.eventLabel,
    );
  }

  loadPopup({ queryParams, successCallback, finalCallback }) {
    $(this.selectors.overlay).remove();
    this.popupLoading = true;
    sendRequest(this.TEMPLATE_ENDPOINT, {
      action: 'loginToBook',
      tourId: this.tourId,
      queryParams,
    }, (data) => {
      if (data.status === 'OK') {
        $('main').append(data.component);
        successCallback();
      }

      this.popupLoading = false;
      finalCallback();
    });
  }

  showSuccessToast(successText) {
    if ($('.js-login-prompt-confirmation').length) {
      return;
    }

    const $successNotification = $(`<div class="js-login-prompt-confirmation ao-common-travel-agent-popup__toast ao-common-travel-agent-popup__toast-icon ao-common-travel-agent-popup__toast-icon--success">${successText}</div>`);

    $(this.selectors.copyTrigger).parent().append($successNotification);
    setTimeout(() => {
      $successNotification.remove();
    }, 4000);

    sendGoogleEvent(
      this.eventCategory,
      'Click the “Copy link“ CTA',
      this.eventLabel,
    );
  }
}
